<template>
    <v-list>
        <v-list-item to="/dashboard">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item>
            <v-list-item-title>{{ t('agent.dashboard') }}</v-list-item-title>
          </v-list-item>
        </v-list-item>
        <v-list-item to="/performance">
          <v-list-item-icon>
            <v-icon>mdi-chart-line</v-icon>
          </v-list-item-icon>
          <v-list-item>
            <v-list-item-title>{{ t('agent.performance') }}</v-list-item-title>
          </v-list-item>
        </v-list-item>
        <v-list-item to="/earnings">
          <v-list-item-icon>
            <v-icon>mdi-cash</v-icon>
          </v-list-item-icon>
          <v-list-item>
            <v-list-item-title>{{ t('agent.earnings') }}</v-list-item-title>
          </v-list-item>
        </v-list-item>
        <v-list-item to="/sub-agents" v-if="!isStore">
          <v-list-item-icon>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item>
            <v-list-item-title>{{ t('agent.subAgents') }}</v-list-item-title>
          </v-list-item>
        </v-list-item>
        <v-list-item to="/wholesaler" v-else>
          <v-list-item-icon>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item>
            <v-list-item-title>{{ t('agent.wholesaler') }}</v-list-item-title>
          </v-list-item> 
        </v-list-item>
        <v-list-item to="/direct">
            <v-list-item-icon>
              <v-icon>mdi-account-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item>
              <v-list-item-title>{{ t('agent.directList') }}</v-list-item-title>
            </v-list-item>
        </v-list-item>
        <!-- <v-list-item to="/agent/upgrade-rules">
          <v-list-item-icon>
            <v-icon>mdi-arrow-up-bold</v-icon>
          </v-list-item-icon>
          <v-list-item>
            <v-list-item-title>{{ t('agent.upgradeRules') }}</v-list-item-title>
          </v-list-item>
        </v-list-item> -->
    </v-list>
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const props = defineProps({
  walletConnect: {
    type: Object,
    required: true
  }
});
const isStore = ref(false);
onMounted(async () => {
  try {
    const agentInfos = await props.walletConnect.getAgentInfo(props.walletConnect.walletAddress);
    isStore.value = agentInfos.isStore;
  }catch(e) {
    console.log(e);
  }
})
</script> 